import React, { useState, useEffect, memo } from 'react';
import { LoadingSpinner } from '../common/loadingSpinner';
import { useAppDispatch, useAppSelector } from '../redux/hooks'
import { useGetLimitedArticlesQuery } from '../redux/api-slice';
import Article from './Article';
import InfiniteScroll from 'react-infinite-scroll-component';
import { setCurrentPage, setPagination } from '../redux/settings/page-settings-slice';

export default function Results() {
    const dispatch = useAppDispatch();
    const currentFilter = useAppSelector((state) => state.filterState.filters) as any;
    const currentPage = useAppSelector((state) => state.pageSettings.page);
    const limit = useAppSelector((state) => state.pageSettings.limit);
    const pagination = useAppSelector((state) => state.pageSettings.pagination);
    const noResultsText = useAppSelector((state) => state.pageSettings.noResultsText);
    const sortType = useAppSelector((state) => state.pageSettings.sortType);
    const isLandingPage = useAppSelector((state) => state.pageSettings.isLandingPage);
    const { data } = useGetLimitedArticlesQuery({ page: currentPage, limit: limit, filter: currentFilter, sortBy: sortType, landingPage: isLandingPage });

    let fetchMoreData = () => {
        if (data && data.items.length >= data.count) {
            dispatch(setPagination(false));
            return;
        }

        dispatch(setCurrentPage(currentPage + 1));
    }

    useEffect(() => {
        if (data && data.items.length >= data.count) {
            dispatch(setPagination(false));
        } else {
            dispatch(setPagination(true));
        }
    }, [data, dispatch]);

    return (
        <>
            {data ?
                <InfiniteScroll
                    dataLength={data.items.length}
                    next={fetchMoreData}
                    hasMore={pagination && data.items.length < data.count}
                    scrollThreshold={0.6}
                    loader={<LoadingSpinner />}
                    endMessage={<p className="otc-listing-results-final rich-text space-top-md" dangerouslySetInnerHTML={{ __html: noResultsText }}></p>}
                >
                    <ul className="otc-listing-results">
                        {data.items.map((article, index) => (
                            <Article result={article} id={article.id} key={index} />
                        ))}
                    </ul>

                </InfiniteScroll>
                :
                <LoadingSpinner />
            }
        </>
    );
}